import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export interface Payload {
  password: string;
  password2: string;
  token: string;
}

const resetPassword = (makeCall: MakeCall) => (data: Payload) =>
  makeCall<undefined>('POST', `/api/v2/action/reset-password`, { data });

export default resetPassword;
